import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import SecurityIcon from "@mui/icons-material/Security";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import ComputerIcon from "@mui/icons-material/Computer";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import GroupsIcon from "@mui/icons-material/Groups";
import ApartmentIcon from "@mui/icons-material/Apartment";

const servicesData = [
  {
    id: "strategy-management",
    icon: LightbulbIcon,
    title: "Strategy & Management Consulting",
    tagline: "Re-engineer, reposition, and grow with confidence",
    description:
      "We design and deliver business solutions for formation, growth, sustainability, re-engineering, and restructuring grounded in research into local and international economic and business environments. Our team helps organisations enhance operational efficiency, productivity, competitiveness, and profitability across all sectors, including the oil and gas sector.",
    offerings: [
      "Business Strategy & Corporate Planning",
      "Corporate Re-engineering & Restructuring",
      "Repositioning & Performance Improvement",
      "Feasibility Studies & Business Research",
      "Portfolio Management",
      "Investment Appraisal",
      "Operational Procedures & Manuals Development",
    ],
  },
  {
    id: "corporate-finance",
    icon: AccountBalanceIcon,
    title: "Corporate Finance",
    tagline: "Strategic financial structuring to scale your business",
    description:
      "Our Corporate Finance team provides end-to-end advisory on transactions, capital strategy, and financial structuring. We help businesses raise capital, prepare business plans and investment proposals, access funding from legitimate sources, and execute deals that create lasting value.",
    offerings: [
      "Mergers & Acquisitions Advisory",
      "Capital Restructuring & Recapitalization",
      "Capital Raising & Debt Structuring",
      "Business Plans & Investment Proposals",
      "Access to Funding & Financing",
      "Business Valuations",
      "Transaction Support & Due Diligence",
      "Financial Modelling & Forecasting",
      "Restructuring & Turnaround Advisory",
    ],
  },
  {
    id: "financial-advisory",
    icon: ShowChartIcon,
    title: "Financial Advisory",
    tagline: "Expert guidance for sound financial decisions",
    description:
      "We support businesses in achieving robust financial management through expert analysis, strategic planning, and hands-on advisory. From day-to-day accounting to complex financial reporting, our team delivers insights that enhance performance and inform sound decision-making.",
    offerings: [
      "Financial Planning & Analysis",
      "Accounting & Financial Reporting",
      "Bookkeeping & Accounting Services",
      "Financial Statement Preparation",
      "Conversion from Local GAAP to IFRS",
      "Account System Set-Up & Optimisation",
      "Tax Advisory & Regulatory Compliance",
      "Tax Planning & Strategy",
    ],
  },
  {
    id: "hr-consulting",
    icon: GroupsIcon,
    title: "Human Resource & Management Consulting",
    tagline: "Build, develop, and optimise your people",
    description:
      "We provide human resource and management consulting that helps organisations attract, develop, and retain the right talent. From executive search to systems design and implementation, we strengthen the people and structures behind your performance.",
    offerings: [
      "Executive Search & Recruitment",
      "Selection & Placement",
      "Management Development & Training Programs",
      "Staff Audits",
      "HR Systems Review, Design & Implementation",
      "Organisational Structure & Workforce Planning",
    ],
  },
  {
    id: "risk-compliance",
    icon: SecurityIcon,
    title: "Risk & Compliance",
    tagline: "Safeguard your operations with robust frameworks",
    description:
      "Our Risk & Compliance practice helps organisations identify, assess, and mitigate risks while building governance structures that promote accountability, transparency, and regulatory adherence. We also undertake regulatory filings and liaise with Nigerian and international regulatory authorities on behalf of our clients.",
    offerings: [
      "Enterprise Risk Assessments",
      "Governance, Risk & Internal Control Frameworks",
      "Internal Policies, Procedures & Operational Manuals",
      "Regulatory Compliance Advisory",
      "Regulatory Filings & Returns",
      "Regulatory Liaison (Local & International)",
      "Business Control Services",
      "Anti-Money Laundering (AML) Compliance",
    ],
  },
  {
    id: "audit",
    icon: FactCheckIcon,
    title: "Audit",
    tagline: "Build trust through transparency and accountability",
    description:
      "Our Audit Services provide objective and thorough evaluations of your financial statements, internal controls, and operational processes. We go beyond compliance to deliver insights that strengthen your business, improve processes, and instil confidence among stakeholders.",
    offerings: [
      "External Audit",
      "Internal Audit",
      "Compliance Audit",
      "Forensic Audit & Investigation",
      "Process & Operational Audit",
      "Audit Committee Advisory",
    ],
  },
  {
    id: "it",
    icon: ComputerIcon,
    title: "Technology & Digital Solutions",
    tagline: "Software, systems, and digital transformation",
    description:
      "We design, develop, programme, and deploy software, digital, and technology-enabled solutions, and provide information technology and telecommunications consulting. Whether building a product from scratch or modernising your infrastructure, we help you operate smarter and stay competitive locally and internationally.",
    offerings: [
      "Custom Software Design & Development",
      "Software Deployment & Implementation",
      "Systems Integration",
      "IT & Telecommunications Consulting",
      "Infrastructure Support",
      "Digital Transformation Strategy",
      "Website Design & Development",
      "Data Analytics & Business Intelligence",
    ],
  },
  {
    id: "property",
    icon: ApartmentIcon,
    title: "Property Consultancy",
    tagline: "Acquire, manage, and optimise property",
    description:
      "We provide property consultancy, acquisition, management, and advisory services for our clients and for the firm helping you make sound, well-researched real estate and asset decisions that protect and grow value.",
    offerings: [
      "Property Acquisition Advisory",
      "Property & Asset Management",
      "Real Estate Investment Advisory",
      "Property Portfolio Strategy",
    ],
  },
];

export default servicesData;
